import loadFroged from '../../lib/loadFroged'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

function FrogedInstallation(...args) {
  if (!window.Froged) {
    return console.debug('Froged is not currently installed', ...args)
  }
  window.frogedSettings = {
    appId: "6e8hmq"
  }
  return window.frogedSettings
}

export default {
  state: {
    loaded: false,
  },
  getters: {},
  mutations: {
    [mutations.FROGED_LOADED](state, loaded) {
      state.loaded = loaded
    },
  },
  actions: {
    async [actions.FROGED_BOOT]({ state, rootGetters, commit }, user) {
      if (state.loaded) {
        return
      }

      const config = rootGetters[getters.AUTH_GET_USER_CONFIG]
      // if (!config.FROGED_SCRIPT_KEY) {
      //   return
      // }

      console.log('actions')
      await loadFroged()
      commit(mutations.FROGED_LOADED, true)
      FrogedInstallation()
    },
  },
}
